import { gql } from '@apollo/client'

import { PRIORITY_TASK_FRAGMENT } from '../fragments'

const CREATE_PRIORITY_TASK_MUTATION = gql`
  mutation createPriorityTaskMutation($data: PriorityTaskCreateInput!) {
    createPriorityTask(data: $data) {
      ...PriorityTaskFragment
    }
  }
  ${PRIORITY_TASK_FRAGMENT}
`

export default CREATE_PRIORITY_TASK_MUTATION
